(function ($) {
    "use strict";
    var w = $(window).width();   //画面のwidthを取得
    var speed = 400; // スクロール速度設定

    var area1 = null;
    var area2 = null;

    $(document).ready(function () {
        if(w <= 479){
            $('#js-next-step').css('display','none');
            $('#js-next-step-sp').css('display','block');
            $('.jzd-step2').css('display', 'none');
            $('.jzd-step3').css('display', 'none');
        }else{
            if($('a').hasClass('form-error')){
                $('#js-next-step').css('display','none');
                $('.jzd-step2').css('display','block');
                $('.jzd-step3').css('display','block');
            }else{
                $('#js-next-step').css('display','block');
                $('.jzd-step2').css('display','none');
                $('.jzd-step3').css('display','none');
            }
            $('#js-next-step-sp').css('display','none');
        }

        $('#js-next-step').click(function(){
            $('.jzd-step2').css('display','block');
            $('.jzd-step3').css('display','block');
            $('#js-next-step').css('display','none');
            $('.sp-jzd-step2-btn').css('display','none');
            $('.sp-jzd-step3-btn').css('display','none');
        });

        $('#edit-profile-birth-year,#edit-profile-birth-month,#edit-profile-birth-day').change(function() {
            var selected_year = $('#edit-profile-birth-year').val()
            var selected_month = $('#edit-profile-birth-month').val()
            var selected_day = $('#edit-profile-birth-day').val()
            if($("#edit-profile-birth-day option[value='_null']").length == 0) {
                $('#edit-profile-birth-day').prepend($("<option>").val("_null").text(""));
            }
            if(selected_month == 4 || selected_month == 6 || selected_month == 9 || selected_month == 11 ){
                if(selected_day == 31){
                    $('#edit-profile-birth-day').val('_null');
                }
            }else if((Math.floor(selected_year%4 == 0)) && (Math.floor(selected_year%100 != 0)) || (Math.floor(selected_year%400 == 0))){
                if(selected_month == 2){
                    if(selected_day > 29){
                        $('#edit-profile-birth-day').val('_null');
                    }
                }
            }else{
                if(selected_month == 2){
                    if(selected_day > 28){
                        $('#edit-profile-birth-day').val('_null');
                    }
                }
            }
        });

        //スマホステップ1で次へが押された場合ステップ2を表示
        $('#js-next-step-sp').click(function(){
            $('.sp-jzd-step2').css('display','block');
            $('.sp-jzd-step1').css('display','none');
            $('.sp-jzd-step3').css('display','none');
            $('.js-next-step-sp2').css('display','block');
            $('.sp-jzd-step2-btn').css('display','block'); //ステップ2ボタンを表示

            $('.step-froms-indicator li').eq(0).removeClass("active");
            $('.step-froms-indicator li').eq(1).addClass("active");

            // $('body,html').animate({scrollTop:$('.step-froms-indicator sp-only')}, speed, 'swing');
            $("html,body").animate({scrollTop:$('.step-froms-indicator').offset().top});
            // return false;
        });
        //スマホステップ2で次へが押された場合ステップ3を表示
        $('#js-next-step-sp2').click(function(){
            $('.sp-jzd-step3').css('display','block');
            $('.sp-jzd-step1').css('display','none');
            $('.sp-jzd-step2').css('display','none');
            $('.sp-jzd-step3-btn').css('display','block');

            $('.step-froms-indicator li').eq(1).removeClass("active");
            $('.step-froms-indicator li').eq(2).addClass("active");

            // $('body,html').animate({scrollTop:$('.step-froms-indicator sp-only')}, speed, 'swing');
            $("html,body").animate({scrollTop:$('.step-froms-indicator').offset().top});
            // return false;
        });

        //スマホステップ2で戻るが押された場合ステップ1を表示
        $('#js-prev-step-sp').click(function(){
            $('.sp-jzd-step2').css('display','none');
            $('.sp-jzd-step3').css('display','none');
            $('.sp-jzd-step1').css('display','block');

            $('.step-froms-indicator li').eq(1).removeClass("active");
            $('.step-froms-indicator li').eq(0).addClass("active");

            // $('body,html').animate({scrollTop:$('.step-froms-indicator sp-only')}, speed, 'swing');
            $("html,body").animate({scrollTop:$('.step-froms-indicator').offset().top});
            // return false;
        });
        //スマホステップ3で戻るが押された場合ステップ2を表示
        $('#js-prev-step-sp2').click(function(){
            $('.sp-jzd-step1').css('display','none');
            $('.sp-jzd-step3').css('display','none');
            $('.sp-jzd-step2').css('display','block');

            $('.step-froms-indicator li').eq(2).removeClass("active");
            $('.step-froms-indicator li').eq(1).addClass("active");

            // $('body,html').animate({scrollTop:$('.step-froms-indicator sp-only')}, speed, 'swing');
            $("html,body").animate({scrollTop:$('.step-froms-indicator').offset().top});
            // return false;
        });

        $("input"). keydown(function(e) {
            if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                return false;
            } else {
                return true;
            }
        });

        $('#edit-profile-job-area1').change(function() {
            area1 = $('#edit-profile-job-area1').val();
            area2 = $('#edit-profile-job-area2').val();

            if(area1 == area2){
                $('#edit-profile-job-area2').val(0);
            }

            $('#edit-profile-job-area2 option').prop('disabled', false);
            $('#edit-profile-job-area2 option[value="'+area1+'"]').prop('disabled', true);

        });

        $('#edit-profile-job-area2').change(function() {
            area1 = $('#edit-profile-job-area1').val();
            area2 = $('#edit-profile-job-area2').val();

            if(area1 == area2){
                $('#edit-profile-job-area1').val(0);
            }

        });


        $(window).resize(function(){
            var urlHash = location.hash;    // URLのアンカー（#以降の部分）を取得
            w = $(window).width();
            //  width479以下だったらスマホ用に切り替え
            if(w <= 479){
                if(urlHash){
                    if (urlHash == '#step-open') {
                        $('.sp-jzd-step1').css('display','block');
                        $('.sp-jzd-step2').css('display','none');
                        $('.sp-jzd-step3').css('display','none');
                    }else if (urlHash == '#sp-step') {
                        $('.sp-jzd-step1').css('display','block');
                        $('.sp-jzd-step2').css('display','none');
                        $('.sp-jzd-step3').css('display','none');
                    }else if (urlHash == '#sp-step2') {
                        $('.sp-jzd-step1').css('display','none');
                        $('.sp-jzd-step2').css('display','block');
                        $('.sp-jzd-step3').css('display','none');
                    }else if (urlHash == '#sp-step3') {
                        $('.sp-jzd-step1').css('display','none');
                        $('.sp-jzd-step2').css('display','none');
                        $('.sp-jzd-step3').css('display','block');
                    }
                }
                $('#js-next-step').css('display','none');
                $('#js-next-step-sp').css('display','block');
                $('#js-next-step-sp').css('display','block');
                $('.sp-jzd-step2-btn').css('display','block');
                $('.sp-jzd-step3-btn').css('display','block');
            }else{  //  PCサイズ
                // URLにアンカーが存在する場合
                if(urlHash){
                    $('#js-next-step').css('display','none');
                    $('#js-next-step-sp').css('display','none');
                    $('.sp-jzd-step1').css('display','block');
                    $('.sp-jzd-step2').css('display','block');
                    $('.sp-jzd-step3').css('display','block');
                    $('.sp-jzd-step2-btn').css('display','none');
                    $('.sp-jzd-step3-btn').css('display','none');
                }else{
                    $('#js-next-step').css('display','block');
                    $('#js-next-step-sp').css('display','none');
                }
            }
          });
    });

    $(window).on('load', function() {
        var urlHash = location.hash;    // URLのアンカー（#以降の部分）を取得
        if(w <= 479){
            if(urlHash){
                $('.sp-jzd-step1').css('display','block');
                $('.sp-jzd-step2').css('display','none');
                $('.sp-jzd-step3').css('display','none');
            }
            $('#js-next-step').css('display','none');
            $('#js-next-step-sp').css('display','block');
            $('#js-next-step-sp').css('display','block');
            $('.sp-jzd-step2-btn').css('display','block');
            $('.sp-jzd-step3-btn').css('display','block');
        }
    });
})(jQuery);
